import React from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { Box, Button } from '@mui/material';
import { uploadedFileUrl } from '../../../utils/constants/links';
import { Icon } from '@iconify/react/dist/iconify.js';

const ViewAttachment = ({ attachmentFileName }) => {
  const [open, setOpen] = React.useState(false);
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <GlobalDialog
      maxWidth={'md'}
      fullWidth
      title={'Quotation Attachment'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            disabled={!attachmentFileName}
            size="small"
            color="info"
            variant="outlined"
            onClick={() => {
              setOpen(true);
            }}
            startIcon={<Icon style={{ marginRight: '3px' }} icon="carbon:view-filled" width="20" height="24" />}
          >
            View
          </Button>
        </>
      }
      content={
        <Box sx={{ height: '70vh', width: '100%' }}>
          {!attachmentFileName ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '18px',
                color: 'gray',
                fontWeight: 500,
              }}
            >
              No Attachment Available
            </Box>
          ) : attachmentFileName?.toLowerCase().endsWith('.pdf') ? (
            <iframe
              src={`${uploadedFileUrl}/${attachmentFileName}`}
              width="100%"
              height="100%"
              title="Uploaded PDF"
              style={{ border: 'none', borderRadius: 4 }}
            ></iframe>
          ) : (
            <img
              src={`${uploadedFileUrl}/${attachmentFileName}`}
              alt="Uploaded File"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                borderRadius: 4,
                border: '1px solid #ccc',
              }}
            />
          )}
        </Box>
      }
    />
  );
};

export default ViewAttachment;
